<template>
    <component :is="hasLink ? 'a' : 'div'" 
               :class="'activity__block'"
               :href="hasLink ? eventLink.url : null"
               :target="hasLink && eventLink.target ? eventLink.target : null">
        <figure v-html='eventItem.featured_media'></figure>

        <div v-if="hasLink && isExternalLink" class="news__block__icon" v-html="ico_external"></div>

        <div  class="activity__type__holder" >
            <div class="activity__type generic-medium" v-for="type in this.eventItem.type">
                {{ type.name }}
                <span></span>
            </div>

        </div>

        <h4>
            {{ eventItem.post_title }}
        </h4>

        <div v-if="eventItem.acf.description" v-html="eventItem.acf.description" class="content">
        </div>

        <ul class="activity__block__details">
            <li>
                <div v-html="ico_pin"></div>
                <span class="generic-medium"> {{ eventItem.acf.location }}</span>
            </li>
            <li>
                <div v-html="ico_calendar"></div>
                <span class="generic-medium">{{ formatDate }}</span>
            </li>
            <li>
                <div v-html="ico_clock"></div>
                <span class="generic-medium">{{time}}</span>
            </li>
        </ul>

    </component>

</template>

<script>

export default {
    props: {
        eventItem: Object,
    },

    data() {
        return {
            ico_pin: window.ico_pin || this.$parent.ico_pin,
            ico_calendar: window.ico_calendar || this.$parent.ico_calendar,
            ico_clock: window.ico_clock || this.$parent.ico_clock,
            ico_external: window.ico_external || this.$parent.ico_external,
        }
    },
    created() {
        
    },
    mounted() {
       
    },
    computed:{
        hasLink() {
            return this.eventItem.acf && 
                   this.eventItem.acf.link && 
                   this.eventItem.acf.link.url && 
                   this.eventItem.acf.link.url.trim() !== '';
        },
        eventLink() {
            if (this.hasLink) {
                return {
                    url: this.eventItem.acf.link.url,
                    target: this.eventItem.acf.link.target || null
                };
            }
            return { url: null, target: null };
        },
        isExternalLink() {
            return this.hasLink && 
                   this.eventLink.target && 
                   this.eventLink.target === '_blank';
        },
        time() {
            if(!this.eventItem.acf.start_time){
                return '';
            }

            if ( ! this.eventItem.acf.end_time || this.eventItem.acf.start_time == this.eventItem.acf.end_time ) {
                return this.eventItem.acf.start_time;
            }

            return (this.eventItem.acf.start_time + " - " + this.eventItem.acf.end_time );
        },
        types() {
            if(this.eventItem.type.length > 0){
                let typesArray = []
                for(let i=0; i < this.eventItem.type.length; i++) {
                    typesArray[i]=this.eventItem.type[i].name;
                }

                return typesArray.toString();
            }else{
                return ''
            }
        },
        formatDate() {
            if (!this.eventItem.acf.date) {
                return '';
            }

            const dateParts = this.eventItem.acf.date.split('/');
            if (dateParts.length !== 3) {
                return this.eventItem.acf.date;
            }

            const month = parseInt(dateParts[0], 10);
            const day = parseInt(dateParts[1], 10);
            const year = parseInt(dateParts[2], 10);

            const date = new Date(year, month - 1, day);
            const options = { weekday: 'long', month: 'short', day: 'numeric' };
            const formattedDate = date.toLocaleDateString('en-US', options);

            return formattedDate;
        }
    },
}

</script>


